import { Navigate, RouteObject } from "react-router-dom";
import { Routes } from "../routes";
import addPermissions from "routes/guards/routePermissions";
import { lazy } from "react";

const Analytics = lazy(() => import("views/analytics"));
const Dashboard = lazy(() => import("views/dashboard"));
const Payments = lazy(() => import("views/transactions/payments"));
const Refunds = lazy(() => import("views/transactions/refund"));
const RefundsDetails = lazy(() => import("views/transactions/refund/refundDetails"));
const Chargebacks = lazy(() => import("views/transactions/chargeback"));
const ChargeBacksDetails = lazy(() => import("views/transactions/chargeback/chargebackDetails"));
const Customers = lazy(() => import("views/customers"));
const PaymentDetails = lazy(
  () => import("views/transactions/payments/paymentDetails")
);
const AuditLog = lazy(
  () => import("views/auditLog")
);

const Transfer = lazy(() => import("views/transfer"));
const TransferDetails = lazy(() => import("views/transfer/transferDetails"));
const Invoices = lazy(() => import("views/transfer/invoices"));
const InvoicesDetails = lazy(
  () => import("views/transfer/invoices/invoiceDetails")
);
const InvoicesCreate = lazy(
  () => import("views/transfer/invoices/createInvoice")
);
const PaymentLinks = lazy(() => import("views/transfer/paymentLinks"));
const MangeStoreFronts = lazy(
  () => import("views/storeFronts/")
);
const Settings = lazy(() => import("views/settings"));

const StoreFrontOrders = lazy(
  () => import("views/storeFronts/storeFrontOrders")
);
const StoreFrontProducts = lazy(
  () => import("views/storeFronts/storeFrontProducts")
);
const SubAccounts = lazy(() => import("views/subAccounts"));
const CustomerDetails = lazy(() => import("views/customers/customerDetails"));
const StoreFrontProductDetails = lazy(() => import("views/storeFronts/storeFrontProducts/storeFrontProductDetails"));
const StoreFrontOrderDetails = lazy(() => import("views/storeFronts/storeFrontOrders/storeFrontOrdersDetails"));
const Recipients = lazy(() => import("views/transfer/recipients"));
const PaymentLinkDetails = lazy(() => import("views/transfer/paymentLinks/paymentLinkDetails"));

// all dashboard related routes
export const dashboardRoutes = () => {
  const devRoutes: Array<RouteObject> = [];

  if(process.env.NODE_ENV === 'development') {
    devRoutes.push({
      path: Routes.analytics,
      element: addPermissions(Analytics, []) as any,
    })
  }
  return [
    ...devRoutes,
    {
      path: Routes.dashboard,
      element: addPermissions(Dashboard, []),
    },
    {
      path: Routes.transactionsPayment,
      element: addPermissions(Payments, []),
    },
    {
      path: Routes.transactionsRefunds,
      element: addPermissions(Refunds, []),
    },
    {
      path: Routes.transactionsRefundsDetails,
      element: addPermissions(RefundsDetails, []),
    },
    {
      path: Routes.transactionsChargeBack,
      element: addPermissions(Chargebacks, []),
    },
    {
      path: Routes.transactionsChargeBackDetails,
      element: addPermissions(ChargeBacksDetails, []),
    },
    {
      path: Routes.transactionsPaymentDetails,
      element: addPermissions(PaymentDetails, []),
    },
    {
      path: Routes.customers,
      element: addPermissions(Customers, []),
    },
    {
      path: Routes.customer,
      element: addPermissions(CustomerDetails, []),
    },
    {
      path: Routes.transfersRemittance,
      element: addPermissions(Transfer, []),
    },
    {
      path: Routes.transfersRemittanceDetails,
      element: addPermissions(TransferDetails, []),
    },
    {
      path: Routes.transfersInvoices,
      element: addPermissions(Invoices, []),
    },
    {
      path: Routes.transfersInvoicesDetails,
      element: addPermissions(InvoicesDetails, []),
    },
    {
      path: Routes.transfersInvoicesCreate,
      element: addPermissions(InvoicesCreate, []),
    },
    {
      path: Routes.recipients,
      element: addPermissions(Recipients, []),
    },
    {
      path: Routes.transfersPaymentLinks,
      element: addPermissions(PaymentLinks, []),
    },
    {
      path: Routes.settingsBase,
      element: addPermissions(Settings, []),
    },
    {
      path: Routes.manageStorefronts,
      element: addPermissions(MangeStoreFronts, []),
    },
    {
      path: Routes.storefrontProducts,
      element: addPermissions(StoreFrontProducts, []),
    },
    {
      path: Routes.storefrontProductDetails,
      element: addPermissions(StoreFrontProductDetails, []),
    },
    {
      path: Routes.storefrontOrders,
      element: addPermissions(StoreFrontOrders, []),
    },
    {
      path: Routes.storefrontOrder,
      element: addPermissions(StoreFrontOrderDetails, []),
    },
    {
      path: Routes.subAccounts,
      element: addPermissions(SubAccounts, []),
    },
    {
      path: Routes.storefronts,
      element: <Navigate to={Routes.manageStorefronts} replace />,
    },
    {
      path: Routes.settings,
      element: <Navigate to={Routes.settingsProfileSetup} replace />,
    },
    {
      path: Routes.auditLog,
      element: addPermissions(AuditLog, []),
    },
    {path: Routes.transfersPaymentLinkDetails, element: addPermissions(PaymentLinkDetails, [])},
    { path: Routes.app, element: <Navigate to={Routes.dashboard} replace /> },
  ] as RouteObject[];
};
